<template>
  <div class="searchbar-container">
    <BookingSearchBar is-booking-home />
  </div>
</template>

<script setup>
import { onMounted } from "vue";

import { useBookingStore } from "../stores/booking";
import { useTranslationsStore } from "../stores/translations";

import BookingSearchBar from "./BookingSearchBar.vue";

const bookingStore = useBookingStore();
const translationsStore = useTranslationsStore();
translationsStore.setLocale(translationsStore.getShopifyLocale());

onMounted(() => {
  bookingStore.resetStore();
  bookingStore.journeyType = "center"; // set default manually
});
</script>

<style scoped></style>
